import { useReferralRewards } from '@src/hooks/useReferrals';
import { HStack, Skeleton, Text, VStack } from 'ui_2';
import aleo from '@assets/aleo_token.svg';
import parc from '@assets/parc_token.png';

type ReferralStatsAssetsProps = {
  aleoAmount: number;
  parcAmount: number;
};

const ReferralStatsCount = ({ count }: { count: number }) => {
  return (
    <VStack className='min-h-[90px] items-center justify-center rounded-[5px] bg-gray-50 p-4'>
      <Text font='bold-lg'>{count}</Text>
      <Text font='medium-xs'>Referred</Text>
    </VStack>
  );
};

const ReferralStatsAssets = ({
  aleoAmount,
  parcAmount,
}: ReferralStatsAssetsProps) => {
  return (
    <VStack className='min-h-[90px] items-center justify-center rounded-[5px] bg-gray-50 p-4'>
      {aleoAmount > 0 && (
        <HStack className='items-center gap-2'>
          <img src={aleo} width={18} />
          <Text font='bold-lg'>{Number(aleoAmount.toFixed(1))}</Text>
        </HStack>
      )}
      <HStack className='items-center gap-2'>
        <img src={parc} width={20} />
        <Text font='bold-lg'>{parcAmount}</Text>
      </HStack>
      <Text font='medium-xs'>Earned</Text>
    </VStack>
  );
};

export const ReferralStats = () => {
  const { data, isLoading } = useReferralRewards();

  if (isLoading) {
    return (
      <HStack className='grid grid-cols-2'>
        <Skeleton />
        <Skeleton delay={1} />
      </HStack>
    );
  }

  if (!data) return null;

  return (
    <HStack className='w-full justify-center'>
      <HStack className='grid w-full max-w-[400px] grid-cols-2 justify-center gap-4'>
        <ReferralStatsAssets
          aleoAmount={data.aleoAmount}
          parcAmount={data.parcAmount}
        />
        <ReferralStatsCount count={data.referrals} />
      </HStack>
    </HStack>
  );
};
